import React, { useState, useEffect } from 'react';
import { HeagleRenderer } from '../types';

interface TotalConnectionsProps {
  renderers: HeagleRenderer[];
}

const TotalConnections: React.FC<TotalConnectionsProps> = ({ renderers }) => {
  const totalConnections = renderers.reduce((sum, renderer) => sum + renderer.client_count, 0);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('ko-KR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };

  return (
    <div className="total-connections">
      <h2>총 접속수: {totalConnections}개</h2>
      <span className="current-time">{formatTime(currentTime)}</span>
    </div>
  );
};

export default TotalConnections;
